<template>
  <div class="balanceLog-container">
    <div class="balanceLog-top">
      <van-cell
        value="余额记录"
        is-link
        :border="false"
        to="/pages/balanceLog/balanceRecord"
      >
        <template #title>
          <span class="custom-title">余额：</span>
          <span class="moneny-number"
            >￥{{ userInfo && userInfo.balance ? userInfo.balance : 0 }}</span
          >
        </template>
      </van-cell>
      <div class="moneny-list">
        <div
          v-for="item in monenyList"
          :key="item.id"
          :class="['moneny-item', item.id === active ? 'active' : '']"
         @click="itemClick(item.id,item.isShow)"
        >
          <template v-if="item.isShow !==0">
            <span class="reality-moneny">￥{{ item.depositAmount }}</span>
          <span class="presented">赠送￥{{ item.extraAmount }}</span>
          <span class="presented">赠送{{ item.extraPoint }}积分</span>
          </template>
          <template v-else>
            <span class="reality-moneny">{{ item.depositAmount }}</span>
          </template>
        </div>
      </div>
      <van-field
        v-model="digit"
        type="digit"
        label="自定义金额:"
        v-if="show"
        :autofocus="true"
        :border="false"
      />
    </div>
    <div class="tip">温馨提示：自定义金额不会有赠送</div>
    <van-button class="toTopUp selected fixedClass" @click="confirmClick">
      去充值
      <span>￥{{ amount }}</span>
    </van-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      monenyList: [],
      active: 1,
      digit: undefined,
      show: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    activeId() {
      if(this.monenyList.length === 0) {
        return 0
      }else {
        return this.active
      }
    },
    amount() {
      let amount = 0;
      if (this.digit) {
        amount = this.digit;
      } else {
        if (this.active) {
          this.monenyList.forEach((item) => {
            if (item.id === this.active) {
              amount = item.depositAmount;
            }
          });
        }
      }
      return amount;
    },
  },

  created() {
    this.deposit();
  },
  methods: {
    deposit() {
      this.$http.request(this.$http.pathMap.deposit, "post",{status:1}).then((res) => {
        this.monenyList = [...res.data,{depositAmount:'其他金额',isShow:0}];
      });
    },
    itemClick(id,isShow) {
      if(isShow === 0) {
        this.topUpClick()
        return
      }
      this.active = id;
      this.digit = undefined;
      this.show = false;
    },
    topUpClick() {
      this.active = undefined;
      this.show = true;
    },
    confirmClick() {
      if(this.amount <= 0) return this.$toast('金额大于0')
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", this.wxPay, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.wxPay);
          document.attachEvent("onWeixinJSBridgeReady", this.wxPay);
        }
      } else {
        this.wxPay();
      }
    },
    wxPay() {
      let { amount } = this;
      let param ={
        amount:amount*1,
        id:this.activeId,
        type:undefined
      }
      if(this.digit) {
        param.type = 1
      }else {
        param.type = 0
      }
      let that = this;
      that.$http
        .request(that.$http.pathMap.memberDeposit, "post",param)
        .then((res) => {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            { ...res.data },
            function (data) {
              if (data.err_msg == "get_brand_wcpay_request:ok") {
                // that.$router.replace({
                //   path: "/pages/money/paySuccess",
                //   query: {
                //     orderNo,
                //   },
                // });
                window.location.reload()
              } else if (data.err_msg == "get_brand_wcpay_request:cancel") {
                this.$dialog.alert({
                  title: "提示",
                  message: "取消了支付",
                });
              } else {
                this.$dialog.alert({
                  title: "提示",
                  message: "支付失败",
                });
              }
            }
          );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.van-cell {
  background: none;
  padding: 0;
  margin: 20px 0;
}
.moneny-number {
  font-size: 14px;
  color: $font-color-spec;
}
.balanceLog-container {
  padding: 15px;
  background: #f8f8f8;
  .balanceLog-top {
    .moneny-list {
      display: flex;
      margin-top: 10px;
      flex-wrap: wrap;

      .moneny-item {
        width: 32%;
        padding: 10px 15px;
        margin-bottom: 7px;
        border: 1px solid $base-color;
        color:  $base-color;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        margin-right: 7px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .reality-moneny {
          font-size: 18px;
        }
        .presented {
          font-size: 14px;
          color: $font-color-disabled;
        }
      }
      .active {
        background: $base-color;
        color: #fff;
        .presented {
          color: #fff;
        }
      }
    }
  }
  .title {
    margin: 10px;
  }
  .tip {
    margin: 10px;
    margin-left: 0;
    font-size: 14px;
    color: $font-color-disabled;
  }
}
.toTopUp {
  margin-top: 20px;
  width: 100%;
  padding: 5px 0;
  text-align: center;
  border: none;
  background: none;
  border: 1px solid $uni-border-color;
  border-radius: 5px;
  color: #000;
  font-weight: 500;
}
.selected {
  background: $base-color;
  border: none;
  color: #fff;
}
.fixedClass {
  position: fixed;
  width: 370px !important;
  bottom: 10px;
  left: auto;
}
</style>
